import * as React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ReactPaginate from 'react-paginate';
import RebatesFilter from './Components/RebatesFilter';
import RebateListItem from './Components/RebateListItem';
import { postAprobarRebatesApi, deleteRebatesApi } from '../../api/axios';
import { fetchSellersFilter } from '../../actions/sellersActions';
import { fetchRebates, setFiltroRebates } from '../../actions/rebatesActions';
import { limpiarFiltros } from '../../actions/generalActios';
import { toast } from 'react-toastify';
import { filtroUnaSemana } from '../../utilities/fechasFiltro';
import BigSpinner from '../General/BigSpinner';
import BtnToggleFilter from "../General/Filter/BtnToggleFilter";

const fechaFiltro = filtroUnaSemana();

class ListRebates extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 1,
            onFilter: true
        };
    }

    componentDidMount() {
        if (this.props.rebates?.length > 0) return;

        let pag = this.props.filtroRebates?.numeroPagina;
        if (!this.props.emptyFiltro.rebates) pag = 1;

        this.setState({ currentPage: pag != null ? pag : 1 });

        if (this.props.userType.isCategory || this.props.userType.isAdminMod) {
            this.props.fetchSellersFilter({
            Descripcion: "",
                Page: 1,
                PageSize: 100
            });
        }

        this.busquedaRebates();
    }

    busquedaRebates = () => {
        let idSeller = this.props.userType.isAdminMod ? this.props.filtroRebates.idSeller : this.props.idSeller;
        idSeller = this.props.userType.isCategory ? null : idSeller;

        let filtroRebates = this.props.filtroRebates;

        if (!this.props.emptyFiltro.rebates || filtroRebates.fechaHasta === undefined) {
            filtroRebates.fechaHasta = fechaFiltro.hasta;
        }

        if (filtroRebates.fechaDesde === undefined) {
            filtroRebates.fechaDesde = fechaFiltro.desde;
        }

        filtroRebates.idTipoEstado = filtroRebates.idTipoEstado ?? null;

        let params = {
            idSeller: idSeller,
            idTipoEstado: filtroRebates.idTipoEstado,
            skuSeller: filtroRebates.skuSeller,
            skuMarket: filtroRebates.skuMarket,
            fechaDesde: filtroRebates.fechaDesde,
            fechaHasta: filtroRebates.fechaHasta,
            IdTipoUser: this.props.tipoUsuario,
            PageSize: 10,
            page: filtroRebates?.numeroPagina,
        }

        this.props.fetchRebates(params);
    }

    chargeFilterOptions = (options) => {
        this.props.setFiltroRebates(options);
    }

    setInitialPage = () => {
        this.setState({ currentPage: 1 });
    }

    handleEstadoRebate = (idRebate, idEstado) => {
        if (idEstado === 2 && this.props.userType.isSellerAdmin) {
            idEstado = 3;
        }

        const request = {
            idUsuario: this.props.idUsuario,
            idEstado,
            idRebate
        };

        postAprobarRebatesApi(request)
            .then(() => {
                toast.success("Estado de rebate cambiado.");
                this.busquedaRebates();
            })
            .catch(err => {
                const errores = err.response?.data?.errors;
                if (errores) errores.forEach(error => toast.error(error.message));
                else toast.error("No se pudo cambiar el estado rebate.");
            });
    }

    deleteRebate = (idRebate) => {
        deleteRebatesApi(idRebate)
            .then(() => {
                toast.success("Rebate eliminado");
                this.busquedaRebates();
            })
            .catch(err => {
                const errores = err.response?.data?.errors;
                if (errores) errores.forEach(error => toast.error(error.message));
                else toast.error("No pudo eliminarse");
            });
    }

    goToPublicacion = (idPublicacion) => {
        const pathReturn = "/Rebates";
        const rutaDestino = `/Publicaciones/Editar/${this.props.idSeller}/${idPublicacion}`;

        this.props.limpiarFiltros({ ...this.props.emptyFiltro, rebates: false });
        localStorage.setItem("pId", idPublicacion);

        this.props.navigate(rutaDestino, {
            state: {
                pathReturn,
                idSellerPub: this.props.idSeller,
                tieneRebate: true // o false si querés manejarlo dinámicamente
            }
        });
    };


    handlePageChange = (options) => {
        this.props.filtroRebates.numeroPagina = options.selected + 1;
        this.setState({ currentPage: options.selected + 1 });
        this.busquedaRebates();
    }

    render() {
        const { rebates, loadingRebates } = this.props;
        const listaRaw =
            Array.isArray(rebates?.content) ? rebates.content :
                Array.isArray(rebates?.elementos) ? rebates.elementos :
                    Array.isArray(rebates?.data) ? rebates.data :
                        Array.isArray(rebates) ? rebates : [];

        const lista = listaRaw.map((rebate) => {
            const dataRebateRaw = rebate?.dataRebate ?? rebate?.DataRebate ?? rebate?.rebate ?? rebate?.Rebate ?? rebate ?? {};
            const porcentajesRaw = rebate?.porcentajesRebate ?? rebate?.PorcentajesRebate ?? rebate?.porcentajes ?? rebate?.Porcentajes ?? {};
            const tipoPublicacionRaw = rebate?.tipoPublicacion ?? rebate?.TipoPublicacion ?? {};
            const imagenesRaw = Array.isArray(rebate?.imagenes) ? rebate.imagenes : (Array.isArray(rebate?.Imagenes) ? rebate.Imagenes : []);

            return {
                ...rebate,
                titulo: rebate?.titulo ?? rebate?.Titulo ?? "",
                descripcionSeller: rebate?.descripcionSeller ?? rebate?.DescripcionSeller ?? rebate?.seller ?? rebate?.Seller ?? "",
                skuSeller: rebate?.skuSeller ?? rebate?.SkuSeller ?? "",
                skuMarket: rebate?.skuMarket ?? rebate?.SkuMarket ?? "",
                estadoRebate: typeof (rebate?.estadoRebate ?? rebate?.EstadoRebate) === 'string'
                    ? (rebate?.estadoRebate ?? rebate?.EstadoRebate)
                    : ((rebate?.estadoRebate ?? rebate?.EstadoRebate)?.descripcion ?? (rebate?.estadoRebate ?? rebate?.EstadoRebate)?.Descripcion ?? null),
                dataRebate: {
                    id: dataRebateRaw?.id ?? dataRebateRaw?.Id ?? 0,
                    idPublicacion: dataRebateRaw?.idPublicacion ?? dataRebateRaw?.IdPublicacion ?? 0,
                    precioInicial: dataRebateRaw?.precioInicial ?? dataRebateRaw?.PrecioInicial ?? 0,
                    precioFinal: dataRebateRaw?.precioFinal ?? dataRebateRaw?.PrecioFinal ?? 0,
                    aCargoMegatone: dataRebateRaw?.aCargoMegatone ?? dataRebateRaw?.ACargoMegatone ?? 0,
                    aCargoSeller: dataRebateRaw?.aCargoSeller ?? dataRebateRaw?.ACargoSeller ?? 0,
                    fechaInicio: dataRebateRaw?.fechaInicio ?? dataRebateRaw?.FechaInicio ?? null,
                    fechaVencimiento: dataRebateRaw?.fechaVencimiento ?? dataRebateRaw?.FechaVencimiento ?? null,
                    unidades: dataRebateRaw?.unidades ?? dataRebateRaw?.Unidades ?? 0,
                    unidadesRestantes: dataRebateRaw?.unidadesRestantes ?? dataRebateRaw?.UnidadesRestantes ?? 0
                },
                porcentajesRebate: {
                    porcentajeTotalDescuento: porcentajesRaw?.porcentajeTotalDescuento ?? porcentajesRaw?.PorcentajeTotalDescuento ?? 0,
                    porcentajeMegatone: porcentajesRaw?.porcentajeMegatone ?? porcentajesRaw?.PorcentajeMegatone ?? 0,
                    porcentajeSeller: porcentajesRaw?.porcentajeSeller ?? porcentajesRaw?.PorcentajeSeller ?? 0
                },
                tipoPublicacion: {
                    descripcion: tipoPublicacionRaw?.descripcion ?? tipoPublicacionRaw?.Descripcion ?? ""
                },
                imagenes: imagenesRaw.map((img) => ({
                    ...img,
                    urlImagen: img?.urlImagen ?? img?.UrlImagen ?? ""
                }))
            };
        });

        const cantidadTotal = rebates?.total ?? rebates?.cantidadTotal ?? rebates?.Total ?? lista.length ?? 0;

        return (
            <div className="row justify-content-between algin-items-center">
                <div className="col-12 col-md-auto">
                    <h3 className="text-themecolor color-rojo-megatone">Gestión de Rebates</h3>
                </div>

                <div className="col-12 col-md-auto text-end text-md-start pb-2 pb-md-0">
                    <BtnToggleFilter
                        show={this.state.onFilter}
                        handleShow={() => this.setState({ onFilter: !this.state.onFilter })}
                    />
                </div>

                <div hidden={!this.state.onFilter}>
                    <RebatesFilter
                        filtro={this.props.emptyFiltro.rebates === false ? this.props.filtroRebates : ""}
                        setInitialPage={this.setInitialPage}
                        chargeFilterOptions={this.chargeFilterOptions}
                    />
                </div>

                <div hidden={!loadingRebates}>
                    <BigSpinner />
                </div>

                <div>
                    {loadingRebates || lista.length === 0 ? null : (
                        lista.map((rebate, i) => {
                            const { dataRebate, estadoRebate, imagenes, porcentajesRebate, skuMarket, skuSeller, tipoPublicacion } = rebate;
                            return (
                                <RebateListItem
                                    key={i}
                                    idRebate={dataRebate?.id}
                                    idPublicacion={dataRebate?.idPublicacion}
                                    descripcionSeller={rebate.descripcionSeller}
                                    imagen={imagenes?.[0]?.urlImagen ?? ""}
                                    titulo={rebate.titulo}
                                    skuSeller={skuSeller}
                                    skuMarket={skuMarket}
                                    precioLista={dataRebate?.precioInicial}
                                    estadoRebate={estadoRebate}
                                    fechaInicio={dataRebate?.fechaInicio}
                                    fechaVencimiento={dataRebate?.fechaVencimiento}
                                    porcentajeTotalDescuento={porcentajesRebate?.porcentajeTotalDescuento}
                                    aCargoMegatone={dataRebate?.aCargoMegatone}
                                    porcentajeMegatone={porcentajesRebate?.porcentajeMegatone}
                                    aCargoSeller={dataRebate?.aCargoSeller}
                                    porcentajeSeller={porcentajesRebate?.porcentajeSeller}
                                    precioFinal={dataRebate?.precioFinal}
                                    unidades={dataRebate?.unidades}
                                    unidadesRestantes={dataRebate?.unidadesRestantes}
                                    onPublicacion={this.goToPublicacion}
                                    deleteRebate={this.deleteRebate}
                                    handleEstadoRebate={this.handleEstadoRebate}
                                    tipoPublicacion={tipoPublicacion ?? { descripcion: "" }}
                                    userType={this.props.userType}
                                />
                            );
                        })
                    )}
                </div>

                <div hidden={cantidadTotal > 0 || loadingRebates}>
                    <h5 className="d-flex justify-content-center m-t-40 m-b-40">
                        NO SE ENCONTRARON RESULTADOS
                    </h5>
                </div>

                <div className="d-flex justify-content-center">
                    <ReactPaginate
                        previousLabel={"Anterior"}
                        nextLabel={"Siguiente"}
                        breakLabel={"..."}
                        pageCount={Math.ceil(cantidadTotal / 10)}
                        marginPagesDisplayed={5}
                        pageRangeDisplayed={10}
                        onPageChange={this.handlePageChange}
                        containerClassName={"pagination"}
                        activeClassName={"active"}
                        forcePage={this.state.currentPage - 1}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    const rb = state.rebates?.rebates ?? {};
    return {
    rebates: rb,
    loadingRebates: state.rebates.loadingRebates,
    idSeller: state.general.idSeller,
    idUsuario: state.general.userId,
    tipoUsuario: state.general.tipoUsuario,
    cantidadTotal: rb?.total ?? rb?.Total ?? rb?.cantidadTotal ?? rb?.CantidadTotal ?? 0,
    filtroRebates: state.rebates.filtro,
    emptyFiltro: state.general.limpiar,
    userType: state.general.userType
    };
};

const ConnectedComponent = connect(mapStateToProps, {
    setFiltroRebates,
    fetchRebates,
    fetchSellersFilter,
    limpiarFiltros
})(ListRebates);

export default function Wrapper(props) {
    const navigate = useNavigate();
    return <ConnectedComponent {...props} navigate={navigate} />;
}
